import { render, staticRenderFns } from "./ColorPickerTextfield.vue?vue&type=template&id=2f721943"
import script from "./ColorPickerTextfield.vue?vue&type=script&lang=js"
export * from "./ColorPickerTextfield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports